import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { COMMON, REPORT } from "../config/apiEndPoint";
import { GET, POST } from "config/api.config";

const unwrapReportMailSourceList = (payload) => {
  const data = payload?.data ?? payload;
  if (Array.isArray(data)) return data;
  const inner = data?.records ?? data?.rows ?? data?.items ?? data?.data;
  return Array.isArray(inner) ? inner : [];
};

/** Maps `GET common/report-mail-source` rows (`{ id, display }`) to react-select options. */
export const mapReportMailSourceOptions = (payload) =>
  unwrapReportMailSourceList(payload)
    .map((item) => {
      const value = String(item?.id ?? item?.value ?? "").trim();
      const label = String(
        item?.display ?? item?.label ?? item?.email ?? item?.name ?? value
      ).trim();
      return value ? { value, label } : null;
    })
    .filter(Boolean);

/** GET `common/report-mail-source` */
export const fetchReportMailSourceOptions = async () => {
  try {
    const response = await GET(COMMON.REPORT_MAIL_SOURCE);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Report/in-progress/filter` */
export const submitInProgressReportFilterData = async (data = {}) => {
  try {
    const response = await POST(REPORT.IN_PROGRESS_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Report/in-progress/send` */
export const submitInProgressReportSendData = async (data = {}) => {
  try {
    const response = await POST(REPORT.IN_PROGRESS_SEND, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
